import { css } from '@emotion/core';

import { flexSpace, SPACE_COMPACT } from '@/styles';

export const main = [
  flexSpace,
  css`
    flex-wrap: nowrap;
  `,
];

export const buttonIcon = css`
  margin-right: ${SPACE_COMPACT}px;
`;
